import {
	ApiRequestData,
	LocalizedContent,
	LocalizedNonce,
} from "../types/types";

declare global {
	interface Window {
		midtownMembershipsVerify: LocalizedNonce;
		midtownMembershipsContent: LocalizedContent;
	}
}

export type Endpoint = {
	url: string;
	requestMethod: string;
};

const getStepData = async (
	stepNo: Number,
	endpoint: Endpoint,
	requestBody: ApiRequestData,
) => {
	try {
		const headers = {
			"Content-Type": "application/json",
			...(window?.midtownMembershipsVerify?.nonce_verification_enabled && {
				"X-WP-Nonce": window?.midtownMembershipsVerify?.nonce || "",
			}),
		};

		const response = await fetch(endpoint.url, {
			method: endpoint.requestMethod,
			headers,
			credentials: "same-origin",
			...(endpoint.requestMethod === "POST" && {
				body: JSON.stringify({
					data: requestBody,
				}),
			}),
		});

		if (!response.ok) {
			throw new Error(`HTTP error! Status: ${response.status}`);
		}

		const result = await response.json();

		// Exception for hubspot.
		if (stepNo === 1) {
			if (result?.data?.get_club_id === 0 || result?.data?.get_contact === "") {
				throw new Error(`Details not found`);
			}
		}

		return result;
	} catch (error) {
		const message =
			error instanceof Error ? error.message : "Something went wrong";
		throw new Error(message);
	}
};

export default getStepData;
